import { createApp, watch } from "vue";
import { wecomaRedirectActive } from "@sazka/utils/gdpr/use-wecoma-redirect";
import useUserAccount, { isUserLoggedIn } from "../use-user-account";
import { useWecomaIntegration } from "@sazka/utils/gdpr/use-wecoma-integration";
import { WecomaConstants } from "@sazka/utils/gdpr/wecoma-constants";
import { fetchWecomaAuthKey } from "@/api-connector/sazka-api/methods/wecoma-api";
import { logException } from "@sazka/utils/logger/use-app-logger";
import ConsentBar from "@sazka/utils/gdpr/consent-bar.vue";

let hasLoaded = false;

async function init() {
    if (hasLoaded) return;

    hasLoaded = true;

    initConsentBar();

    if (wecomaRedirectActive) {
        const { waitForUserAccount } = useUserAccount();

        await waitForUserAccount();

        watch(
            isUserLoggedIn,
            async (newIsUserLoggedIn) => {
                if (newIsUserLoggedIn) {
                    window.location.href = await getLinkToPrefCenter();
                }
            },
            { immediate: true }
        );
    }
}

async function initConsentBar() {
    const { shouldCookieBarOpen } = useWecomaIntegration();
    try {
        if (!(await shouldCookieBarOpen())) return;

        const component = createApp(ConsentBar);

        const root = document.createElement("div");
        document.body.appendChild(root);
        component.mount(root);
    } catch (ex: unknown) {
        logException("wecoma-sa", ex, { message: "error while initializng consent bar" });
    }
}

async function getAuthKey() {
    const { waitForUserAccount } = useUserAccount();

    const userAccountData = await waitForUserAccount();
    if (!isUserLoggedIn.value) {
        return null;
    }

    try {
        return await fetchWecomaAuthKey(userAccountData.value.clientId);
    } catch (ex: unknown) {
        logException("wecoma-sa", ex, { message: "Error getting auth key" });
    }
}

async function getLinkToPrefCenter() {
    const authKey = await getAuthKey();

    const domain = appSettings["Integrations:Wecoma:Domain"];

    let link = `${domain}?locale=cs-CZ`;

    if (authKey) {
        link += `&key=${WecomaConstants.WECOMA_CODE}&authKeys=${authKey}`;
    }
    return link;
}

export function useGdpr() {
    return {
        init,
        getLinkToPrefCenter,
    };
}
